import { render } from "./PlayerCampaign.vue?vue&type=template&id=3656f1a2&scoped=true"
import script from "./PlayerCampaign.vue?vue&type=script&lang=js"
export * from "./PlayerCampaign.vue?vue&type=script&lang=js"

import "./PlayerCampaign.vue?vue&type=style&index=0&id=3656f1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3656f1a2"]])

export default __exports__